import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=7b6cf8f9&scoped=true"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=7b6cf8f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6cf8f9",
  null
  
)

export default component.exports